function getBodyZoom() { 
    return parseFloat(document.body.style.zoom) || 1;
}

var origin = 0;
var JustSize = 
window.onresize = function() {
    if(!origin) {
        var calc = window.innerWidth / 1920;

        document.getElementsByTagName('body')[0].style.zoom = calc;
    }

    justify();
};

function justify() {
    var doms = document.getElementsByClassName('full-screen');

    var height = window.innerHeight / getBodyZoom();

    for(let dom in doms) {
        if(doms.hasOwnProperty(dom)) {
            let d = doms[dom];

            d.style.zoom =  height/1080;
        }
    }
}
/**
 * 根据body调整zoom
 */
class JustResize {
    justAll(){
        this.justZoom();
        this.justHeight();
    }
    justHeight(){
        var doms = document.getElementsByClassName('full-screen-autoheight');

        for(let index in doms){
            if(doms.hasOwnProperty(index)){
                let dom = doms[index];
                dom.style.height = window.innerHeight / getBodyZoom() + 'px';
            }
        }
    }
    justZoomByHeight() {
        if(this.justed) {
            justify();
        }else {
            this.needJust = true;
        }
    }
    justZoom() {
        JustSize();

        this.justed = true;

        if(this.needJust) {
            this.needJust = false;
            this.justZoomByHeight();
        }
    }
}

var singleTon = new JustResize()

export default singleTon;



// WEBPACK FOOTER //
// ./src/api/justHeight.js


// WEBPACK FOOTER //
// ./src/api/justHeight.js